import React from "react";
import CcgRoutePremiumPage from "../components/CcgRoutePremiumPage";
import { generatedCcgRouteConfigs } from "../data/generatedCcgRouteConfigs";
import PostcodeQuotenew from "./PostcodeQuotenew";
import "./CcgRoutePremium.css";

const GeneratedCcgRoutePage = ({ routeKey }) => {
  const route = generatedCcgRouteConfigs[routeKey];
  if (!route) return null;
  return <CcgRoutePremiumPage route={route} QuoteComponent={PostcodeQuotenew} />;
};

export default GeneratedCcgRoutePage;
